﻿import { useState, useEffect } from 'react';
import { SelectListOption } from "../../../components/Fields/Types";
import { useTranslations } from "../../../contexts/translationContext";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service"

export default function useSelectListOptions(optionsUrl?: string, nullOption?: string, currentValue?: string | number, getData?: boolean) {
    const [options, setOptions] = useState<SelectListOption[]>()
    const { translate } = useTranslations();
    const { handleException } = useNotifications();

    useEffect(() => {
        console.log('getData', getData)

        if (!optionsUrl || getData === false)
            return

        console.log('optionsUrl', optionsUrl)

        if (currentValue) {
            if (optionsUrl.indexOf('?') > -1) {
                optionsUrl += '&currentValue=' + currentValue;
            }
            else {
                optionsUrl += '?currentValue=' + currentValue;
            }
        }

        if (nullOption) {
            if (optionsUrl.indexOf('?') > -1) {
                optionsUrl += '&nullOption=-- ';
            }
            else {
                optionsUrl += '?nullOption=-- ';
            }

            translate(nullOption).then(translated => {
                if (optionsUrl) {
                    DataService.get<SelectListOption[]>(optionsUrl + translated)
                        .then(response => setOptions(x => response))
                        .catch(e => handleException(e));
                }
            });
        }
        else {
            console.log('optionsUrl', optionsUrl)
            if (optionsUrl) {
                DataService.get<SelectListOption[]>(optionsUrl)
                    .then(response => setOptions(x => response))
                    .catch(e => handleException(e));
            }
        }
    }, [optionsUrl, nullOption, getData]);

    return options;
}